export const JobScreensEnums = Object.freeze({
  TYPE_DATABASE: "database",
  LABEL_EVLUATE: "Evluate",
  TRANSACTION_DEBIT: "Debit",
  TAB_JOB_DETAILS: "JobDetails",
  TAB_ASSESSMENTS: "Assessments",
  TAB_SOURCE: "source",
  TAB_VENDORS: "vendors",
  TAB_VENDOR: "vendor",
  TAB_APPLICATIONS: "applications",
  TAB_SELF: "self",
  STATUS_ALL: "All",
  JOB_TYPE_REMOTE: "remote",
  JOB_TYPE_ONSITE: "onSite",
  JOB_TYPE_FULLTIME: "fullTime",
  TAB_TYPE_APPLICATION: "Application",
  TAB_TYPE_SELF: "Self",
  TAB_TYPE_VENDOR: "Vendor",
  SCAN_STATUS_UNSCANNED: "unscanned",
  SCAN_STATUS_SCANNED: "scanned",
});
